import DynamicHeader from '@/components/Shared/DynamicHeader'
import { Sidebar } from '@/components/Sidebar'
import { useBrandQuery } from '@/services/brands/queries'
import { Outlet } from 'react-router-dom'
import { LayoutProvider, useLayout } from './LayoutContext'
import styles from './layout.module.css'

const LayoutContent = () => {
  const { data: brand } = useBrandQuery()
  const { title, subTitle } = useLayout()

  return (
    <div className={styles.layout}>
      <Sidebar />
      <main className={styles.main}>
        <DynamicHeader brandLogoUrl={brand?.brandLogoUrl} title={title} subTitle={subTitle} />
        <div className={styles.content}>
          <Outlet />
        </div>
      </main>
    </div>
  )
}

export const Layout = () => {
  return (
    <LayoutProvider>
      <LayoutContent />
    </LayoutProvider>
  )
}
